module.exports = __webpack_public_path__ + "img/hydraulic_arm_overview_video_splash.5805e8e3.jpg";